export default function MissionSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-20 w-72 h-72 bg-cyan-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-blue-600 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-cyan-500/10 backdrop-blur-sm rounded-full text-cyan-400 mb-6 border border-cyan-500/30">
            <i className="ri-lightbulb-line"></i>
            <span className="text-sm font-semibold">Our Mission</span>
          </div>
          <h2 className="text-5xl font-bold text-white mb-6">
            Empowering Innovation Through Knowledge
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            We're dedicated to making cutting-edge technology accessible to everyone. Our expert writers break down complex topics into engaging, actionable insights that drive innovation forward.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          <div className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-sm rounded-2xl p-8 border border-cyan-500/20 hover:border-cyan-500/40 transition-all hover:shadow-xl hover:shadow-cyan-500/20">
            <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center mb-6 shadow-lg shadow-cyan-500/30">
              <i className="ri-team-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">2M+ Readers</h3>
            <p className="text-gray-400 leading-relaxed">
              A global community of tech enthusiasts, developers, and innovators who trust our insights to stay ahead of the curve.
            </p>
          </div>

          <div className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-sm rounded-2xl p-8 border border-cyan-500/20 hover:border-cyan-500/40 transition-all hover:shadow-xl hover:shadow-cyan-500/20">
            <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center mb-6 shadow-lg shadow-cyan-500/30">
              <i className="ri-article-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">1,850+ Articles</h3>
            <p className="text-gray-400 leading-relaxed">
              Comprehensive coverage of AI, blockchain, quantum computing, and emerging technologies that shape our future.
            </p>
          </div>

          <div className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-sm rounded-2xl p-8 border border-cyan-500/20 hover:border-cyan-500/40 transition-all hover:shadow-xl hover:shadow-cyan-500/20">
            <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center mb-6 shadow-lg shadow-cyan-500/30">
              <i className="ri-star-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">98% Satisfaction</h3>
            <p className="text-gray-400 leading-relaxed">
              Our readers consistently rate our content as accurate, insightful, and essential for staying informed in tech.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
